const firebaseConfig = {
    apiKey: "AIzaSyCGkOce-_pLLmer1Onwp6CS-0-TdMDjY_I",
    authDomain: "qmu-docs.firebaseapp.com",
    databaseURL: "https://qmu-docs.firebaseio.com",
    projectId: "qmu-docs",
    storageBucket: "qmu-docs.appspot.com",
    messagingSenderId: "710440947286",
    appId: "1:710440947286:web:d550254392cf0d1a9075f7"
};
export default firebaseConfig;